export enum FilterTypes {
  InputField = 'empty',
  DatePicker = 'date',
  TrueFalse = 'boolean',
}
